import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=d46198c8&scoped=true&"
import script from "./OtherInfo.vue?vue&type=script&lang=ts&"
export * from "./OtherInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OtherInfo.vue?vue&type=style&index=0&id=d46198c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46198c8",
  null
  
)

export default component.exports